import {
    PAYMENT_GATEWAY_REQ,
    PAYMENT_GATEWAY_SUCCESS,
    PAYMENT_GATEWAY_ERROR,
    ADD_MONEY_VALUE,
    PAYMENT_GATEWAY_RESET_VALUE,
    TRANSACTION_CONFIRMATION_REQUEST,
    TRANSACTION_CONFIRMATION_SUCCESS,
    TRANSACTION_CONFIRMATION_ERROR
} from "../actionType";

const initialState = {
    isLoading: false,
    gatewayData: null,
    errorGateway: null,
    addMoneyAmount: null,
    transConfirm:null,
    transConfirmError:null
};

const investFundReducer = (state = initialState, action: any) => {
    const { type, payload } = action;
    switch (type) {
        case PAYMENT_GATEWAY_REQ:
            return {
                ...state,
                isLoading: true,
            }

        case PAYMENT_GATEWAY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                gatewayData: payload,
            }
        case PAYMENT_GATEWAY_ERROR:
            return {
                ...state,
                isLoading: false,
                errorGateway: payload,
            }
        case ADD_MONEY_VALUE:
            return {
                ...state,
                isLoading: false,
                addMoneyAmount: payload,
            }
        case PAYMENT_GATEWAY_RESET_VALUE:
            return {
                ...state,
                isLoading: false,
                errorGateway: null,
                gatewayData:null
            }
        case TRANSACTION_CONFIRMATION_REQUEST:
            return {
                ...state
            }
        case TRANSACTION_CONFIRMATION_SUCCESS:
            return {
                ...state, 
                transConfirm:payload
            }
        case TRANSACTION_CONFIRMATION_ERROR:
            return {
                ...state, 
                transConfirmError:payload
            }
        default:
            return state;
    }
}
export default investFundReducer;